<template>
  <div class="container">
    <div class="info">
      <div class="tit">{{ $t('finance').loan }}<svg-icon class-name="ssvgs" icon-class="history" @click="$router.push({ name: 'LoanList' })" /></div>
      <!-- 借款区间 -->
      <div class="lable">{{ $t('finance').LoanRange }}</div>
      <van-field v-model="LimitAmount" readonly>
        <template #right-icon>
          <span style="color: var(--ntext_color)">USDT</span>
        </template>
      </van-field>
      <!-- 借款金额 -->
      <div class="lable">{{ $t('finance').LoanAmount }}</div>
      <van-field v-model="Amount" type="number" :placeholder="$t('recharge').amountMsg">
        <template #right-icon>
          <span style="color: var(--ntext_color)">USDT</span>
        </template>
      </van-field>
      <!-- 详细家庭地址 -->
      <div class="lable">{{ $t('finance').homeAddress }}</div>
      <van-field v-model="homeAddress" :placeholder="$t('finance').homeAddressTips"></van-field>
      <!-- 紧急联系人 -->
      <div class="lable">{{ $t('finance').emergencyContact }}</div>
      <van-field v-model="emergencyContact" :placeholder="$t('finance').emergencyContactTips"></van-field>
      <!-- 紧急联系人手机号码 -->
      <div class="lable">{{ $t('finance').emergencyPhone }}</div>
      <van-field v-model="emergencyPhone" :placeholder="$t('finance').emergencyPhoneTips"></van-field>
      <!-- 紧急联系人邮箱 -->
      <div class="lable">{{ $t('finance').emergencyEmail }}</div>
      <van-field v-model="emergencyEmail" :placeholder="$t('finance').emergencyEmailTips"></van-field>
      <!-- 是否有属于自己的房产 -->
      <div class="lable">{{ $t('finance').isHouse }}</div>
      <van-radio-group v-model="isHouse" direction="horizontal">
        <van-radio name="1" checked-color="var(--text_color)" icon-size="15px">{{ $t('finance').yesTxt }}</van-radio>
        <van-radio name="0" checked-color="var(--text_color)" icon-size="15px">{{ $t('finance').noTxt }}</van-radio>
      </van-radio-group>
      <!-- 如有房产请提供房产归属证明图片 -->
      <div class="lable">{{ $t('finance').houseImg }}</div>
      <div class="up_img">
        <van-uploader :after-read="justAfterRead">
          <img v-if="houseImg" :src="baseUrl + houseImg" />
          <van-icon v-else name="photo-o" color="var(--text_color)" size="50" />
        </van-uploader>
      </div>
      <!-- 证件正面 (身份证/护照/驾驶证) -->
      <div class="lable">{{ $t('finance').certImg }}</div>
      <div class="up_img">
        <van-uploader :after-read="justAfterRead2">
          <img v-if="certImg" :src="baseUrl + certImg" />
          <van-icon v-else name="photo-o" color="var(--text_color)" size="50" />
        </van-uploader>
      </div>
      <!-- 证件反面 (身份证/护照/驾驶证) -->
      <div class="lable">{{ $t('finance').certBackImg }}</div>
      <div class="up_img">
        <van-uploader :after-read="justAfterRead3">
          <img v-if="certBackImg" :src="baseUrl + certBackImg" />
          <van-icon v-else name="photo-o" color="var(--text_color)" size="50" />
        </van-uploader>
      </div>
      <!-- 信用分截图-->
      <div class="lable">{{ $t('finance').trustImg }}</div>
      <div class="up_img">
        <van-uploader :after-read="justAfterRead4">
          <img v-if="trustImg" :src="baseUrl + trustImg" />
          <van-icon v-else name="photo-o" color="var(--text_color)" size="50" />
        </van-uploader>
      </div>
      <!-- 借款期限 -->
      <!-- <div class="lable">{{ $t('finance').loanTerm }}</div>
      <div class="dayInfo">
        <div class="item" :class="yieldInfo.days == item.days ? 'active' : ''" v-for="(item, index) in loanSetting.item"
          :key="`yield${index}`" @click="onYield(item)">
          <div class="day">{{ item.days }} {{ $t('finance').day }}</div>
        </div>
      </div> -->
      <!-- 日利息率 -->
      <!-- <div class="tips">{{ $t('finance').Dailyinterestrate }}<span>{{ yieldInfo.interest }}%</span></div> -->
      <!-- 总利息 -->
      <!-- <div class="tips">{{ $t('finance').Totalinterest }}<span>{{ totalInterest }} USDT</span></div> -->
      <!-- 还款方式 -->
      <!-- <div class="tips">{{ $t('finance').Repaymentmethod }}<span>{{ $t('finance').Repaymentofmaturity }}</span></div>
      <div class="line"></div> -->
      <!-- 预估应还 -->
      <!-- <div class="tips">{{ $t('finance').Estimatedreturn }}<span>{{ Number(Amount) + Number(totalInterest) }}  USDT</span></div> -->
      <!-- 借款协议 -->
      <div class="footer"> <van-checkbox icon-size="12" v-model="checkedPass" checked-color="var(--text_color)" style="margin-right: 10px;"></van-checkbox>{{ $t('finance').Ihavereadandagree }}<span
          @click="goContent(7, $t('finance').LoanAgreement)">《{{ $t('finance').LoanAgreement }}》</span>
      </div>
      <!-- 按钮 -->
      <van-button block :loading="btnloading" @click="handleSub">{{ $t('finance').Immediatelymoney }}</van-button>
    </div>
  </div>
</template>

<script>
import orderApi from '@/api/order'
import systemApi from '@/api/system'
import userApi from '@/api/user'
import { EventBus } from '@/utils/event-bus'

export default {
  components: {
  },
  data() {
    return {
      baseUrl: window.baseURL,
      btnloading: false,
      checkedPass: true,
      Amount: '',
      LimitAmount: '',
      loanSetting: {},
      yieldInfo: {},
      totalInterest: 0,
      homeAddress: '',
      emergencyContact: '',
      emergencyPhone: '',
      emergencyEmail: '',
      isHouse: '1',
      houseImg: '',
      certImg: '',
      certBackImg: '',
      trustImg: '',
    }
  },
  mounted() {
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    this.getMemberInfo()
    this.getLoanSetting()
  },
  methods: {
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      // 实名认证校验
      if (res.user.authenticationStatus != '2' && res.user.authenticationStatus != '3' && res.user.authenticationStatus != '4') {
        this.$dialog.confirm({
          title: this.$t('trade').authTips,
          confirmButtonText: this.$t('public').confirm,
          confirmButtonColor: 'var(--text_color)',
          cancelButtonText: this.$t('public').cancel,
          cancelButtonColor: 'var(--ntext_color)',
        })
          .then(() => {
            this.$router.push({ name: 'Auth' })
          })
          .catch(() => {
            this.$router.go(-1)
          });
      }
    },
    // 房产照片
    async justAfterRead(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.houseImg = res.fileName
    },
    // 证件照片
    async justAfterRead2(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.certImg = res.fileName
    },
    // 证件照反面
    async justAfterRead3(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.certBackImg = res.fileName
    },
    // 信用分截图
    async justAfterRead4(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.trustImg = res.fileName
    },
    //选择利率
    onYield(val) {
      this.yieldInfo = val
      this.onInputAmount()
    },
    //输入金额
    onInputAmount() {
      if (this.Amount) {
        this.totalInterest = (this.Amount * (this.yieldInfo.interest / 100) * this.yieldInfo.days).toFixed(6).replace(/\.?0+$/, '')
      } else {
        this.totalInterest = 0
      }
    },
    // 获取贷款配置
    async getLoanSetting() {
      const res = await systemApi.getLoanSetting()
      this.loanSetting = res.loanSetting
      this.LimitAmount = this.loanSetting.minAmount + ' - ' + this.loanSetting.maxAmount
      // this.yieldInfo = this.loanSetting.item[0]
    },
    // 跳转内容
    async goContent(type, title) {
      const res = await systemApi.getContentList({ type: type })
      this.$router.push({ name: 'Detail', query: { Name: title, id: res.rows[0].contentLocalizationId } })
    },
    // 提交
    async handleSub() {
      if (!this.checkedPass)
        return false
      if (!this.Amount) {
        this.$toast({ message: this.$t('recharge').amountMsg })
        return false
      }
      // 最低
      if (this.Amount < this.loanSetting.minAmount) {
        this.$toast(this.$t('finance').Minimumloanamount + this.loanSetting.minAmount + ' USDT')
        return false
      }
      // 最高
      if (this.Amount > this.loanSetting.maxAmount) {
        this.$toast(this.$t('finance').Maximumloanamount + this.loanSetting.maxAmount + ' USDT')
        return false
      }
      // 家庭地址
      if (!this.homeAddress) {
        this.$toast({ message: this.$t('finance').homeAddressTips })
        return false
      }
      // 紧急联系人
      if (!this.emergencyContact) {
        this.$toast({ message: this.$t('finance').emergencyContactTips })
        return false
      }
      // 紧急联系人手机号码
      if (!this.emergencyPhone) {
        this.$toast({ message: this.$t('finance').emergencyPhoneTips })
        return false
      }
      // 紧急联系人邮箱
      if (!this.emergencyEmail) {
        this.$toast({ message: this.$t('finance').emergencyEmailTips })
        return false
      }
      // 房产归属证明图片
      if (this.isHouse == '1' && !this.houseImg) {
        this.$toast({ message: this.$t('finance').houseImg })
        return false
      }
      // 证件照片
      if (!this.certImg) {
        this.$toast({ message: this.$t('finance').certImgTips })
        return false
      }
      // 证件照反面
      if (!this.certBackImg) {
        this.$toast({ message: this.$t('finance').certBackImgTips })
        return false
      }
      // 信用分截图
      if (!this.trustImg) {
        this.$toast({ message: this.$t('finance').trustImgTips })
        return false
      }
      const form = {
        amount: this.Amount,
        // days: this.yieldInfo.days,
        // interest: this.yieldInfo.interest,
        homeAddress: this.homeAddress,
        emergencyContact: this.emergencyContact,
        emergencyPhone: this.emergencyPhone,
        emergencyEmail: this.emergencyEmail,
        isHouse: this.isHouse,
        houseImg: this.houseImg,
        certImg: this.certImg,
        certBackImg: this.certBackImg,
        trustImg: this.trustImg,
      }
      this.btnloading = true
      await orderApi.createLoanOrder(form)
      this.btnloading = false
      this.$toast(this.$t('finance').Applicationsuccessfulreview)
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding-top: 110px;

  .info {
    margin: 0 auto;
    max-width: 780px;

    .tit {
      font-size: 36px;
      font-weight: bold;
      color: var(--text_color);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .ssvgs {
        width: 20px;
        height: 20px;
        color: var(--text_color);
      }
    }
  }

  .lable {
    margin-top: 30px;
    font-size: 15px;
    color: var(--text_color);
  }

  .up_img {
    width: 170px;
    height: 107px;
    border-radius: 10px;
    background: var(--info_color);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 30px;

    img {
      width: 170px;
      height: 107px;
      border-radius: 10px;
    }
  }

  .dayInfo {
    margin-right: -15px;
    display: flex;
    align-items: center;
    justify-content: left;
    flex-wrap: wrap;
    margin-bottom: 20px;

    .item {
      margin-top: 10px;
      margin-right: 10px;
      width: 109px;
      padding: 15px;
      border-radius: 10px;
      background: var(--info_color);

      .day {
        text-align: center;
        font-size: 15px;
        font-weight: bold;
        color: var(--text_color);
      }
    }

    .active {
      background: var(--text_color);
      color: var(--background_color);
      // border: 1px solid var(--text_color);
      position: relative;

      .day {
        color: var(--background_color);
      }
    }
  }

  .line {
    margin-top: 15px;
    height: 1px;
    background: var(--info_color);
  }

  .tips {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: var(--ntext_color);

    span {
      color: var(--text_color);
    }
  }

  .footer {
    margin-top: 50px;
    font-size: 14px;
    color: var(--ntext_color);
    display: flex;
    align-items: center;

    span {
      color: var(--text_color);
      font-weight: bold;
    }
  }

  .van-button {
    margin-top: 30px;
    background: var(--text_color);
    height: 50px;
    border-radius: 25px;
    border: 0;
    font-size: 16px;
    color: var(--background_color);

    &:hover {
      opacity: 0.8;
    }
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

.van-cell {
  margin-top: 10px;
  background: var(--background_color);
  border: 1px solid var(--info_color);
  height: 50px;
  padding: 10px;
  border-radius: 10px;
  font-size: 14px;
  // font-weight: bold;
  &:focus-within {
    border: 1px solid var(--text_color);
    box-shadow: 1px 1px 2px var(--ntext_color);
  }
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__right-icon {
  margin: -10px 8px;
  padding: 0px;
  line-height: normal;
  font-size: 15px;
}

::v-deep .van-checkbox__icon--checked .van-icon {
  color: var(--background_color);
}

::v-deep .van-checkbox__label {
  margin-left: 5px;
  color: var(--text_color);
  font-size: 12px;
  font-weight: bold;
}

::v-deep .van-radio__icon--checked .van-icon {
  color: var(--background_color);
}

::v-deep .van-radio__label {
  margin-left: 8px;
  color: var(--text_color);
  font-size: 13px;
  line-height: normal;
}

::v-deep .van-radio-group--horizontal {
  margin-top: 10px;
  margin-bottom: 30px;
}
</style>
